import {AsyncCacheMap} from "@app/common/helpers/async-cache-map/async-cache-map"
import {fetchOk} from "@cm/utils"
import {DataObject} from "@cm/utils/data-object"
import {from, Observable} from "rxjs"

export class DataObjectContentCache extends AsyncCacheMap<string, Uint8Array, DataObject> {
    constructor() {
        super((_, dataObject: DataObject) => {
            const loadDataBuffer = async (dataObject: DataObject): Promise<Uint8Array> => {
                const response = await fetchOk(dataObject.downloadUrl)
                const buffer = await response.arrayBuffer()
                return new Uint8Array(buffer)
            }

            return from(loadDataBuffer(dataObject))
        })
    }

    evaluateDataObject(dataObject: DataObject): Observable<Uint8Array> {
        return this.get(dataObject.downloadUrl, dataObject)
    }
}
